import { render, staticRenderFns } from "./BillAddReIncome.vue?vue&type=template&id=0b6b6616&scoped=true"
import script from "./BillAddReIncome.vue?vue&type=script&lang=js"
export * from "./BillAddReIncome.vue?vue&type=script&lang=js"
import style0 from "./BillAddReIncome.vue?vue&type=style&index=0&id=0b6b6616&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b6616",
  null
  
)

export default component.exports